<template>
    <div style="display: flex;flex-direction: column;overflow:auto;overflow-x: hidden;">
        <div class="pb-2 m-4" style="border-bottom: 1px solid #242424;position:relative;margin-bottom:0px !important;display: block !important;
    text-align: start;">
            <h6 class="m-0 text-left pl-4">{{$t('Catalog-Pool Mapping')}}</h6>
            <div style="position: relative;inset-inline-start :24px;top: 6px;color: #75756d;">{{$t('On file archive')}}, {{$t('this mapper will be used to select pool to which file needs to be archived')}}</div>
        </div>
        <div class="value-style d-inline-flex bg-transparent rounded text-light input-fields searched-metadata-display-fields"
            style="margin-top:5px;">
            <ul class="tags-display-ul p-0 m-0" style="width:55%">
                <li class="add-screens-styles" @click="openEditOrCreatePoolGroupDialog(true)">
                    <div style="margin-inline-end:10px">
                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-plus-circle" viewBox="0 0 16 16">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                    </svg>
                    </div>
                    <div style="font-size: 15px;line-height: 55px;">{{$t('Create Catalog')}}-{{$t('Pool Mapper')}}</div>
                </li>
                <li v-for="(catalogPool,index) in catalogPoolMappers" :key="catalogPool.id">
                  <div class="pool-rows-styles screen-tags-name-display">
                    <div class="d-flex w-100" style="align-items:center">
                        <div class="screens-name-styles" :title="catalogPool.catalog_name_path"><div>{{ getOnlyName(catalogPool.catalog_name_path) }}</div><span class="dull-the-text">{{ catalogPool.catalog_name_path.split("catalog://0")[1] }}</span></div>

                        <div v-if="catalogPool.pool_ids.length" style="padding-inline-start:15px;width:60%;display: inline-flex;
    flex-direction: row;
    flex-wrap: wrap;">
                          <li v-for="pool in catalogPool.pool_ids" :key="index+'_'+pool.pool_name" class='view-tags'>
                            <span>{{pool.pool_name}}</span>
                          </li>
                        </div>
                    </div>
                    <div class="screen-tags-styles">   
                      <div>
                        </div>   
                        <div class="dropdown">
                            <div class="nav-item nav-link dropdown-toggle" id="bd-versions" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                                <svg width="20" height="1.5em" viewBox="0 0 16 16" class="bi bi-three-dots"  fill="#C5c0c0" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"/>
                                </svg>
                            </div>
                            <div class="dropdown-menu dropdown-menu-md-right p-0" aria-labelledby="bd-versions">
                                <a class="dropdown-item p-2" @click.stop.prevent="editPoolCtalogMapper(catalogPool)">
                                    {{$t('Edit')}}</a>
                                <a class="dropdown-item p-2" @click.stop.prevent="deleteSelectedCatalogPoolMapper(catalogPool.id)">
                                  {{$t('Delete')}}</a>
                            </div>
                        </div>
                    </div>
                  </div>
                </li>
            </ul>
        </div>
        <div class="pb-2 m-4 d-flex" style="border-bottom: 1px solid #242424;position:relative;margin-bottom:0px !important">
            <h6 class="m-0 text-left pl-4">{{$t('Pools')}}</h6>
        </div>
        <div class="value-style d-inline-flex bg-transparent rounded text-light input-fields searched-metadata-display-fields"
            style="margin-top:5px;">
            <ul class="tags-display-ul p-0 m-0" style="width:55%">
                <li class="add-screens-styles" @click="openEditOrCreatePoolGroupDialog(false)">
                    <div style="margin-inline-end:10px">
                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-plus-circle" viewBox="0 0 16 16">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                    </svg>
                    </div>
                    <div style="font-size: 15px;line-height: 55px;">{{$t('Create Pool Group')}}</div>
                </li>
                <li v-for="(pool,index) in poolsArr.slice().reverse()" :key="pool.pool_id">
                  <div class="pool-rows-styles screen-tags-name-display">
                    <div class="d-flex w-100" style="align-items:center">
                        <div v-if="!pool.is_group" class="pool-type-display comm-icon-rtl">             
                          {{$t('Pool')}}
                          </div>
                          <div v-else class="pool-type-display-for-group comm-icon-rtl">
                            {{$t('Group')}}
                          </div>
                        <div class="screens-name-styles" :title="pool.pool_name">{{ pool.pool_name }}-<span class="dull-the-text">{{ pool.pool_owner }}</span></div>
                        <div v-if="pool.is_group && poolGroupsMapper[pool.pool_name] && poolGroupsMapper[pool.pool_name].length" style="padding-inline-start:15px;width:60%;display: inline-flex;
    flex-direction: row;
    flex-wrap: wrap;">
                          <li v-for="poolname in poolGroupsMapper[pool.pool_name]" :key="index+'_'+poolname.pool_name" class='view-tags'>
                            <span>{{poolname.pool_name}}</span>
                          </li>
                          <li v-if="pool.default" class="default-pool view-tags">
                            <div>{{$t('default')}}</div>
                          </li>
                        </div>
                        <div v-else-if="pool.default">
                            <li class="default-pool view-tags" style="margin-inline-start:15px !important">
                              <div>{{$t('default')}}</div>
                            </li>
                        </div>
                    </div>
                    <div class="screen-tags-styles">   
                      <div>
                        </div>   
                        <div class="dropdown">
                            <div class="nav-item nav-link dropdown-toggle" id="bd-versions" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                                <svg width="20" height="1.5em" viewBox="0 0 16 16" class="bi bi-three-dots"  fill="#C5c0c0" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"/>
                                </svg>
                            </div>
                            <div class="dropdown-menu dropdown-menu-md-right p-0" aria-labelledby="bd-versions">
                                <a class="dropdown-item p-2" @click.stop.prevent="setAsDefaultPool(pool.pool_id)">
                                  {{$t('Set as default')}}</a>
                                <a v-if="pool.is_group" class="dropdown-item p-2" @click.stop.prevent="editGroup(poolGroupsMapper[pool.pool_name],pool.pool_name,pool.pool_id)">
                                  {{$t('Edit')}}</a>
                                <a v-if="pool.is_group" class="dropdown-item p-2" @click.stop.prevent="deletePoolGroupButtonClick(pool.pool_id)">
                                  {{$t('Delete')}}</a>
                            </div>
                        </div>
                    </div>
                  </div>
                </li>
            </ul>
        </div>
        <poolGroupWorkspace v-if="showAddOrEditPoolDialog" :isPoolCatalogMapper="isPoolCatalogMapper" :poolsArr="poolsArr" :isEditMode='isEditMode' :selectedPoolGroupInfo="selectedPoolGroupInfo" :selectedCatalogPoolMapperInfo="selectedCatalogPoolMapperInfo" @closeDialog="closeDialog"></poolGroupWorkspace>
    </div>     
</template>

<script>
import {mapActions,mapMutations} from "vuex";
import Utils from "../../components.utils.js";
import poolGroupWorkspace from "./PoolGroupsDialog.vue";

export default {
    data(){
        return{
            isModalVisible:false,
            poolsArr:[],
            selectedPoolOption:{},
            poolGroupsArr:[],
            poolGroupsMapper:{},
            selectedPoolGroupInfo:{'groupname':null,'groupinfo':null,'groupID':null},
            showAddOrEditPoolDialog:false,
            isEditMode:false,
            isPoolCatalogMapper:false,
            catalogPoolMappers:[],
            selectedCatalogPoolMapperInfo:null
        }
    },
    components:{
        poolGroupWorkspace
    },
    methods:{
        ...mapActions("pools",["getFusionPools","updateDefaultPool","createPoolGroup","getAllPoolGroups","editPoolGroup","deletePoolGroup","getCatalogPoolMapper","editCatalogPoolMapper","deleteCatalogPoolMapper"]),
        ...mapMutations("pools",["setPoolsInfo"]),
        getOnlyName(path){
          let tempPathSplit = path.split("/");
          tempPathSplit = tempPathSplit[tempPathSplit.length - 1];
          return tempPathSplit;
        },
        setAsDefaultPool(id){
          let payload = {};
          payload = {"_id":id,"default":true};
          this.updateDefaultPool(payload).then((data) => {
            if (Utils.isAcceptedStatusCode(data.statusCode)) {
                    this.$toast.success(data.message);
                    this.getPools();
                } else {
                    this.$toast.error(data.message);
                }
            });
        },
        closeDialog(doGet){
            this.showAddOrEditPoolDialog = false;
            if(doGet){
              this.getPoolGroups();
              this.getPools();
              this.fetchCatalogPoolMappers();
            }
        },
        openEditOrCreatePoolGroupDialog(isPoolCatalogMapper){
            this.showAddOrEditPoolDialog = true;
            this.isEditMode = false;
            this.isPoolCatalogMapper = isPoolCatalogMapper;
        },
        editGroup(groupInfo,groupName,groupid){
          this.showAddOrEditPoolDialog = true;
          this.selectedPoolGroupInfo = {'groupname':groupName,'groupinfo':groupInfo,'groupID':groupid};
          this.isEditMode = true;
          this.isPoolCatalogMapper = false;
          this.selectedCatalogPoolMapperInfo = null;
        },
        editPoolCtalogMapper(catalogPoolMapperInfo){
          this.selectedCatalogPoolMapperInfo = catalogPoolMapperInfo;
          this.isPoolCatalogMapper = true;
          this.isEditMode = true;
          this.showAddOrEditPoolDialog = true;
        },
        getPools(){
          this.getFusionPools().then((data)=>{
            this.poolsArr = data.pools;
            this.setPoolsInfo(data)
          })
        },
        getPoolGroups(){
          this.getAllPoolGroups().then((data) => {
            this.poolGroupsArr = data.pool_groups;
              for(let i = 0; i < this.poolGroupsArr.length; i++){
                  this.poolGroupsMapper[this.poolGroupsArr[i].pool_group_name] = this.poolGroupsArr[i].pools;
              }
              this.getPools();
          });
        },
        deletePoolGroupButtonClick(id){
          if (
            confirm(
              `Are you sure you want to delete the selected pool group?`
            )
          ) {
          let payload = {};
          payload = {"id":id};
          this.deletePoolGroup(payload).then((data) => {
            if (Utils.isAcceptedStatusCode(data.statusCode)) {
                    this.fetchCatalogPoolMappers();
                    this.getPoolGroups()
                    this.$toast.success(data.message);
                } else {
                    this.$toast.error(data.message);
                }
            });
        }
        },
        fetchCatalogPoolMappers(){
          this.getCatalogPoolMapper().then((data) => {
            this.catalogPoolMappers = data.catalog_pool_mappers;
          });
        },
        deleteSelectedCatalogPoolMapper(id){
          if (
            confirm(
              `Are you sure you want to delete the selected pool-catalog mapper?`
            )
          ) {
          let payload = {};
          payload = {"id":id};
          this.deleteCatalogPoolMapper(payload).then((data) => {
            if (Utils.isAcceptedStatusCode(data.statusCode)) {
                    this.fetchCatalogPoolMappers();
                    this.$toast.success(data.message);
                } else {
                    this.$toast.error(data.message);
                }
            });
        }
        },
    },
    created(){
        this.getPoolGroups();
        this.fetchCatalogPoolMappers();
    },
    beforeDestroy(){
    },
    mounted() {
    },
}
</script>

<style lang="scss" scoped>
    $border-color: 1px solid #4a4a4a;
    $border-color-only:#4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $input-field-height:38px;
    $none-text-color:#4f4f4f;
    $input-field-padding:.375rem 10px;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;
    $tags-background-color:#282d31;
    $tags-border-color:#363636;
    $metadata-border-color-on-hover: #5a5a5a;
    $secondary-border-color: 1px solid #2b2b2b;
    $active-green-color:#28a745;
    $svg-color:#666;
    $learn-about-text-color-hover:#b7b327;
    $learn-about-text-color:#9a9620;
    $danger-color: #dc3545;
    $table-row-border: none;
    $add-button-text-color:#0b7099;
    $add-button-text-color-hover:#0193cc;
    $add-button-border-color:#b7b228;
    $add-button-border-on-hover:#dcd426;
    $add-button-backgroud:#1e1e1e;
    $border-on-hover: 1px solid #61707d;

    .modal-dialog {
      max-width: 500px;
      width: 500px;
      height: 450px;
      margin: 0;
      padding: 0;
    }
  
  .modal-content {
    height: auto;
    min-height: 100%;
    border: 0 none;
    border-radius: 0;
    box-shadow: none;
    background: $primary-background !important;
    border: $secondary-border-color;
    .modal-body{
      background: $primary-background;
      height: 300px;
      overflow: auto;
    }
  }

  .modal {
      text-align: center;
      padding: 0 !important;
      display: block;
      position: fixed;
      inset-inline-start: 0px;
      top: 20%;
  }
  .modal:before {
      content: "";
      display: inline-block;
      height: 100vh;
      vertical-align: middle;
      margin-inline-end: -4px;
      position: fixed;
      width: 100vw;
      inset-inline-start: 0;
      top: 0;
      background: #00000094;
  }
  .modal-dialog {
    display: inline-block;
    text-align: start;
    vertical-align: middle;
  }

    .dull-the-text{
      color:$secondary-text-color;
    }

    .modal-header,.modal-footer{
        border-top: $secondary-border-color !important;
        border-bottom: $secondary-border-color !important;
        background: $secondary-background-color;
        .modal-title{
          color:$text-color;
        }
    }

    .modal-header .close {
        margin: 0px !important;
        padding: 0px !important;
    }

    .modal-footer{
        justify-content: flex-end;
    }

.view-tags {
  font-size:10px!important;
  height: 35px!important;
  display: inline-flex!important;
  margin: 2px!important;
  // border: 1px solid $tags-border-color!important;
  border-radius: 10px!important;
  min-width: 50px!important;
  padding: 0!important;
  text-align: center;
  width: auto!important;
  justify-content: center;
  background: #0087a9;
  align-items: center;
  span {
    padding: 0px 8px !important;
    margin-inline-start: 0px !important;
    font-size:12px !important;
    border-radius: 15px !important;
    color: #fff;
  }
}

.pool-rows-styles{
    display: inline-flex;
    border: 1px solid $border-color-only;
    border-radius: 10px;
    width: 55%;
    margin: 8px 8px;
    position: relative;
}

.upload-fields{
    border: $border-color;
    width: 46%;
    border-radius: 5px;
    position:relative;
}

.users-basic-info-table {
  font-size: 15px;
  tbody {
    margin: 10px;
    .key-div {
      text-align: end;
      color: $dull-text-color;
    }
    .value-div {
      text-align: start;
      margin-inline-start: 10px;
    }
  }
}
table {
  background: transparent;
  thead {
    th {
      color: $dull-text-color;
      border-top: $table-row-border !important;
      border-bottom: $table-row-border !important;
    }
  }
  tbody {
    color: $text-color;
    td {
      border-top: $table-row-border !important;
    }
  }
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.drag-icon{
  color:$dull-text-color;
  cursor: grab;
}

.editIcon {
  margin-inline-start: 9px;
}

.view-tags .show-main-tag-delete, .more-actions-btn {
  visibility: hidden;
}

.view-tags:hover{
  .show-main-tag-delete, .more-actions-btn {
    visibility: visible;
  }
} 

.editIcon{
  visibility:hidden;
}

.value-div:hover .editIcon{
    visibility: visible;
}

.show-tags-delete{
  visibility: hidden;
}

.view-sub-tags:hover .show-tags-delete{
  visibility: visible;
}

.searched-metadata-display-fields{
  height: 100%;
  width: 100%;
  position: relative;
  inset-inline-start: 4%;
}

.show-main-tag-delete {
  margin-inline-start: 5px;
  margin-inline-end: 5px;
}

.search-bar-comm-style{
  height:30px;
  position:relative;
    margin-inline-start: 2%;
    margin-top: 5px;
  input{
    border:0px solid #202020;
    height: 25px;
    padding-inline-start: 3%;
  }
  svg{
    position: absolute;
    inset-inline-start: 12px;
    top: 44%
  }
}

.btn {
  font-size: 14px !important;
  height: 100%;
}

.border {
  border: $border-color !important;
}

.custom-control-label::before {
  background-color: $primary-background;
}

.primary-btn-style {
  margin-top: 1%;
  position: absolute;
  inset-inline-end: 52%;
  button {
    height: 35px;
    width: 70px;
    font-size:14px;
  }
}

.validationmessage {
  color: $danger-color;
  font-size: 11px;
}

/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: $scrollbar-track-background;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $scrollbar-thumb-background;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: $scrollbar-thumb-on-hover-background;
}

input[type="checkbox"]:after {
    line-height: 1.5em;
    content: "";
    display: inline-block;
    width: 20px;
    height: 19px;
    margin-top: 0px;
    margin-inline-start: -1px;
    border: $border-color;
    border-radius: .25em;
    background: transparent;
}

input[type="checkbox"]:checked:after {
  content: "✔";
  color: $active-blue;
  position: absolute;
  font-size: 16px;
  line-height: 1;
  transition: all 0.2s;
  font-family: Helvetica, Arial, sans-serif;
  padding-inline-start: 4px;
  padding-top: 2px;
}

.breadcrumb{
  padding: .75rem 1rem !important;
  background: $primary-background !important;
    .active-text-nav-bar{
        color: $text-color !important;
        text-decoration: none !important
    }
    .active-text-nav-bar:last-child{
            color: $active-blue !important;
            font-size:17px;
    }
    .breadcrumb-item{
        a{
            color: $text-color;
            font-weight:600;
        }
        a:hover{
            text-decoration: underline;
        }
    }    
}

.secondary-btn-style:hover{
  text-decoration: underline;
}
.secondary-btn-style{
  color:$text-color;
}

select{
  border: $border-color;
  background: $secondary-background-color;
  color: $text-color;
  height: 26px;
  width:137px;
  border-radius: 5px;
  padding-inline-start: 8px;
}

.screen-tags-name-display{
    display: inline-flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;
    padding: 8px;
    padding-inline-start: 0px;
    min-height:50px;
}

.screen-tags-styles{
    position: absolute;
    inset-inline-end: 0px;
}

.screen-tags-styles{
  display:inline-flex;
  .view-sub-tags{
    font-size: 12px!important;
    height: 30px;
    display: inline-flex!important;
    margin: 5px!important;
    border: $border-color!important;
    border-radius: 15px!important;
    min-width: 50px!important;
    padding: 0!important;
    text-align: start;
    width: auto!important;
    padding-inline-start: 12px!important;
    justify-content: start;
    padding-top: 2px!important;
    span {
      margin-inline-start: 0!important;
      font-size: 12px!important;
      border-radius: 15px!important;
      position: relative!important;
      top: 3px!important;
      width: 90%;
    }
    .show-tags-delete{
      margin: 3px!important;
      float: inline-end;
      text-align: end;
      width: 25px;
      height: 25px;
      color: $text-color;
      position: relative;
      bottom: 4px;
    }
  }
}

.screens-name-styles{
    margin-inline-start: 12px;
    max-width: 24%;
    text-align: start;
    overflow-wrap: anywhere;
}

.tags-display-ul{
  list-style-type: none;
}

.add-screens-styles{
    display: inline-flex;
    height: 57px;
    border: 1px solid $add-button-border-color;
    border-radius: 10px;
    width: 100%;
    justify-content: center;
    line-height: 52px;
    margin: 8px 8px;
    color:$add-button-text-color;
}

.add-screens-styles:hover{
    border: 1px solid $add-button-border-on-hover;
    color:$add-button-text-color-hover;
}

.empty-field-text-styles{
  color:$none-text-color;
}

.config-desc{
  color: $dull-text-color;
}

.dropdown-toggle{
    svg{
        justify-content: end;
    }
}

.pool-type-display{
  background: #0087a9;
  color: #fff;
  width: 40px;
  font-size: 11px;
  min-height:20px;
  height: auto;
  padding-top:2px;
  border-bottom-right-radius: 8px;
  border-top-right-radius: 8px;
  padding-top: 2px;
}

.pool-type-display-for-group{
  background: #ece3c7 !important;
  width: 40px !important;
  color: #300c0c;
  font-size: 11px;
  min-height:20px;
  height:auto;
  border-bottom-right-radius: 8px;
  border-top-right-radius: 8px;
  padding-top: 2px;
}

.default-pool{
  background: #ab8f08;
  color:black;
  div{
    border-radius: 10px;
    font-size:12px;
  }
}
</style>